// import FJSubtitleRecognitionStore from './store/FJSubtitleRecognitionStore.js';
import useInitProject from './hooks/useInitProject.js';
import FJHeader from './components/FJHeader/FJHeader.tsx';
import classNames from 'classnames';
import styles from './App.module.less';
import useLocalStore from './hooks/useLocalStore.js';
import FJAIStartLandingContainer from './components/FJAIStartLanding/FJAIStartLanding.container.tsx';
import FJFailedPageContainer from './components/FJFailedPage/FJFailedPage.container.tsx';
import FJGeneratingPageContainer from './components/FJGeneratingPage/FJGeneratingPage.container.tsx';
import FJGeneratingSettingsPanelContainer from './components/FJGeneratingSettingsPanelContainer/FJGeneratingSettingsPanel.container.tsx';
import FJDetailsPageContainer from './components/FJDetailsPage/FJDetailsPage.container.tsx';
import { FJ_COMMON_VIEW } from './redux/slice/FJCommonSlice';
import { useAppSelector } from './redux/hooks';
import FJModals from './components/FJModals/FJModals.tsx';
import FJRequirementsUtil from './util/FJRequirementsUtil.js';
import { useEffect } from 'react';
import useActiveViewHistory from './hooks/useActiveViewHistory';
export default function App() {
    useInitProject();
    useLocalStore();
    useActiveViewHistory();
    const activeView = useAppSelector(state => state.common.activeView);
    // useEffect(() => {
    //     FJSubtitleRecognitionStore.loadSDK();
    // }, []);
    useEffect(() => {
        FJRequirementsUtil.eaLog('long_to_shorts_page_view');
    }, []);
    return (
        <>
            <div
                id='app-loading-mask'
                style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#FFF',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 10,
                }}
            ></div>
            <FJHeader />
            <div className={classNames(styles.app_box)}>
                {activeView === FJ_COMMON_VIEW.START_LANDING && <FJAIStartLandingContainer />}
                {activeView === FJ_COMMON_VIEW.SETTING && <FJGeneratingSettingsPanelContainer />}
                {activeView === FJ_COMMON_VIEW.GENERATING && <FJGeneratingPageContainer />}
                {activeView === FJ_COMMON_VIEW.FAILED && <FJFailedPageContainer />}
                {activeView === FJ_COMMON_VIEW.DETAILS && <FJDetailsPageContainer />}

                <FJModals />
            </div>
        </>
    );
}
